import { Photo } from 'model/domain';

export function isBlob(photo: Photo): photo is Blob {
	return 'slice' in photo;
}
